<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <Onboarding
      ref="refOnboarding"
      :userType="getUserType + '-authentication'"
      @updateRoute="$emit('updateRoute')"
    />
    <PasswordConfirmationActivationModal
      @updateEmailAuthentication="changeDados"
      :two-factory-authentication="twoFactoryAuthentication"
      :actionType="actionType"
    />
    <ModalConfirmEmailToken
      v-if="showModalConfirmEmailToken"
      @credentials="getCredentials"
      ref="modalEmailToken"
      @hideModal="(showModalConfirmEmailToken = false), (status = false)"
      :action-type="typeActionLocker"
      :status="status"
    />
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('menuLocker')">
        Cofre de Relatórios
      </h1>
      <h1 class="title">
        <span
          class="pb-2"
          v-text="$ml.get('makeYourAccessReportEvenMoreSecure')"
          >Torne seu acesso aos relatórios ainda mais seguro</span
        >
      </h1>
      <div class="mb-2">
        <b-nav tabs>
          <b-nav-item
            :active="menuItem === 'credential'"
            @click="menuItem = 'credential'"
            id="credential"
          >
            {{ $ml.get("credentials") }}
          </b-nav-item>
          <b-nav-item
            v-if="getUserType === 'company' && getUserRole === 'owner'"
            :active="menuItem === 'config'"
            @click="menuItem = 'config'"
            id="config"
          >
            {{ $ml.get("lockerConfig") }}
          </b-nav-item>
          <b-nav-item
            :active="menuItem === 'access'"
            @click="menuItem = 'access'"
          >
            {{ $ml.get("lockerAccess") }}
          </b-nav-item>
        </b-nav>
      </div>
      <div v-if="menuItem === 'credential'">
        <div class="card mb-3" id="phoneValidation">
          <div class="card-header">
            <h6 class="m-0 p-0 light" v-text="$ml.get('accountRecovery')">
              Recuperação de conta
            </h6>
          </div>
          <div class="card-body">
            <tr
              v-if="loading"
              class="loading row justify-self-center d-flex align-items-center"
            >
              <div class="c-loader m-0"></div>
            </tr>
            <tbody v-if="!loading" class="row">
              <tr class="row w-100">
                <td class="col-10">
                  <strong v-text="$ml.get('phoneValidation')"
                    >Validação de telefone</strong
                  >
                </td>
                <td class="col-10 pl-0 text-muted text-capitalize">
                  <font v-if="phone_hash && phoneValidate"
                    >*****-{{ phone_hash }}</font
                  >
                </td>
                <td class="col-4 pl-0">
                  <div class="row justify-content-end">
                    <label v-if="getUserType === 'company'" class="switch mb-0">
                      <input
                        type="checkbox"
                        @click.prevent="savePhone()"
                        :checked="phoneValidate"
                      />
                      <span class="slider round"></span>
                    </label>
                    <label v-else class="switch mb-0">
                      <input
                        :disabled="showInputSms"
                        type="checkbox"
                        @click.prevent="savePhone()"
                        :checked="phoneValidate"
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
            <hr v-if="showInputSms || showInputPhone" />

            <!-- input for telephone -->
            <div v-show="showInputPhone">
              <transition name="fade">
                <div class="row">
                  <div class="col-18 vue-phone-number-input">
                    <label class="text-muted" v-text="$ml.get('phoneNumber')"
                      >Número de telefone</label
                    >
                    <div class="form-group">
                      <vue-phone-number-input
                        v-model="desc"
                        placeholder="(99) 99999-9999"
                        :default-country-code="'BR'"
                        @update="updatePhoneNumber"
                        :translations="translations"
                      />
                      <label
                        v-if="msgPhoneInvalid"
                        class="lblError"
                        v-text="$ml.get('thePhoneIsNotValid')"
                        >O telefone não é valido.</label
                      >
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="mb-2">
              <RecaptchaV2
                v-if="showInputPhone"
                ref="recaptcha"
                @verify="setRecaptchaToken"
                @expired="tokenRecaptcha = ''"
              />
            </div>
            <button
              v-if="showInputPhone"
              @click="executeRecaptcha('sendSms')"
              :disabled="loadingBtn || !tokenRecaptcha"
              class="btn align-self-center"
            >
              <Spinner v-show="loadingBtn" />
              <span v-show="!loadingBtn" v-text="$ml.get('save')">Salvar</span>
            </button>
            <!-- Input for code sms -->
            <div v-show="showInputSms">
              <div class="row">
                <transition name="fade">
                  <div class="col-8">
                    <label class="text-muted" v-text="$ml.get('smsCode')"
                      >Código SMS</label
                    >
                    <div class="form-group">
                      <the-mask
                        style="width: 302px"
                        class="form-control"
                        v-model="codeSms"
                        :mask="['######']"
                        placeholder="999999"
                      />

                      <label
                       v-if="!errorAwaitNewRequest"
                        style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                        @click="sendCodeSmsAccount"
                        >{{
                          timeLeftSms > 0
                            ? `${$ml.get(
                                "requestNewCodeEmail",
                              )} ${formattedTimeSMS}`
                            : $ml.get("receiveCode")
                        }}</label
                      >
                      <label v-else class="lblError" style="position:relative;" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>
                      <label
                        v-if="validError && !$v.codeSms.required"
                        class="lblError"
                        v-text="$ml.get('enterTheCodeReceivedBySms')"
                        >Informe o código recebido por sms</label
                      >
                      <label
                        v-if="validError && !$v.codeSms.minLength"
                        class="lblError"
                        v-text="$ml.get('enterTheCodeReceivedBySms')"
                        >Informe o código recebido por sms</label
                      >
                    </div>
                    <div class="mb-3">
                      <RecaptchaV2
                        ref="recaptchaPhone"
                        @verify="setRecaptchaToken"
                        @expired="tokenRecaptcha = ''"
                      />
                    </div>
                  </div>
                </transition>
              </div>
              <div class="row mt-1">
                <div class="col">
                  <div class="form-group">
                    <button
                      @click="executeRecaptcha('activePhone')"
                      :disabled="loadingBtn || !codeSms || !tokenRecaptcha"
                      class="btn"
                    >
                      <Spinner v-show="loadingBtn" class="px-5" />
                      <font
                        v-show="!loadingBtn"
                        v-text="$ml.get('validatePhone')"
                        >Validar telefone</font
                      >
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mb-3" id="authentication2fa">
          <div class="card-header">
            <h6 class="m-0 p-0 light" v-text="$ml.get('authentication')">
              Autenticação
            </h6>
          </div>
          <div class="card-body">
            <tr
              v-if="loading || loading2fa"
              class="loading row justify-self-center d-flex align-items-center"
            >
              <div class="c-loader m-0"></div>
            </tr>
            <tbody v-if="!loading && !loading2fa" class="row">
              <tr class="row w-100">
                <td class="col-10">
                  <strong>Two-factor authentication </strong>
                </td>
                <td class="col-10 pl-0 text-muted text-capitalize"></td>
                <td class="col-4 pl-0">
                  <div class="row justify-content-end">
                    <label v-if="getUserType === 'company'" class="switch mb-0">
                      <input
                        type="checkbox"
                        @click.prevent="executeRecaptcha('show2fa')"
                        :checked="authentication2Fa"
                      />
                      <span class="slider round"></span>
                    </label>
                    <label v-else class="switch mb-0">
                      <input
                        type="checkbox"
                        @click.prevent="executeRecaptcha('show2fa')"
                        :checked="authentication2Fa"
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
            <transition v-if="!authentication2Fa && !loading2fa" name="fade">
              <div class="row" v-show="showQrcode">
                <div class="col-24">
                  <hr />
                  <h6 v-text="$ml.get('enableTwoFactorAuthentication')">
                    Habilitar autenticação de dois fatores
                  </h6>
                  <label
                    ><font v-text="$ml.get('makeSureYouHaveACompatibleAppLike')"
                      >Certifique-se de ter um aplicativo compatível como</font
                    >
                    <a
                      target="new_blank"
                      rel="noopener noreferrer"
                      href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=pt_BR&gl=US"
                      >Google Authenticator </a
                    ><font class="mr-1" v-text="$ml.get('or')">ou</font>
                    <a
                      target="new_blank"
                      rel="noopener noreferrer"
                      href="https://duo.com/product/multi-factor-authentication-mfa/duo-mobile-app"
                      >Duo Mobile</a
                    >. <br /><font v-text="$ml.get('openYourApp')"
                      >Abra seu aplicativo.</font
                    >
                    <br /><font v-text="$ml.get('selectAddAccount')"
                      >Selecione "Adicionar conta" ou "+" e digitalize o código
                      QR abaixo</font
                    >
                  </label>
                </div>
                <div
                  class="border border-top-0 border-left-0 border-bottom-0 border-1 pr-4"
                >
                  <p>
                    <img
                      id="image"
                      :src="qrCode"
                      class="img-thumbnail"
                      alt="QRCode Authentication"
                      width="150"
                    />
                  </p>
                </div>
                <div class="col-12 ml-4">
                  <div class="form-group col-24">
                    <label class="text-muted" v-text="$ml.get('useCodeSms')"
                      >Use o código recebido por SMS</label
                    >
                    <the-mask
                      class="form-control"
                      v-model="codeSms"
                      :mask="['### ###']"
                      :placeholder="$ml.get('enterTheCode')"
                    />
                    <div
                      class="col-24"
                      :style="[
                        { display: errorCodeEmail ? 'flex' : '' },
                        {
                          'justify-content': errorCodeEmail
                            ? 'space-between'
                            : '',
                        },
                      ]"
                    >
                      <transition name="fade">
                        <label
                          v-if="errorCodeEmail"
                          style="position: relative; !important"
                          class="lblError"
                          v-text="$ml.get('invalidCodeError')"
                        >
                          O código informado não é válido!
                        </label>
                      </transition>
                      <label
                        v-if="!errorAwaitNewRequest"
                        style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                        @click="sendCodeSms"
                        >{{
                          timeLeftSms > 0
                            ? `${$ml.get(
                                "requestNewCodeEmail",
                              )} ${formattedTimeSMS}`
                            : $ml.get("receiveCode")
                        }}</label
                      >         
                    <label v-else-if="errorAwaitNewRequest && !errorCodeEmail" class="lblError" style="position: relative;" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>
                    </div>
                  </div>
                  <label class="text-muted mb-3">
                    <font class="mr-1" v-text="$ml.get('code')">Código</font>
                    <font class="text-blue">G</font>
                    <font class="text-danger">o</font>
                    <font class="text-warning">o</font>
                    <font class="text-blue">g</font>
                    <font class="text-success">l</font>
                    <font class="text-danger">e</font>
                    Authenticator</label
                  >
                  <div class="row">
                    <transition name="fade">
                      <div class="form-group col">
                        <the-mask
                          class="form-control"
                          v-model="codeTwoFactor"
                          :mask="['### ###']"
                          placeholder="999 999"
                        />
                        <label
                          v-if="validError && !$v.codeTwoFactor.required"
                          class="lblError"
                          v-text="$ml.get('enterTheCode')"
                          >Digite o código</label
                        >
                        <label
                          v-if="validError && !$v.codeTwoFactor.minLength"
                          class="lblError"
                          v-text="$ml.get('enterTheCode')"
                          >Digite o código</label
                        >
                      </div>
                    </transition>
                  </div>
                  <div class="mb-3">
                    <RecaptchaV2
                      ref="recaptcha"
                      @verify="setRecaptchaToken"
                      @expired="tokenRecaptcha = ''"
                    />
                  </div>
                  <div class="row mt-2">
                    <div class="col">
                      <div class="form-group">
                        <button
                          @click="executeRecaptcha('active2fa')"
                          :disabled="!tokenRecaptcha || !codeSms || !codeTwoFactor"
                          class="btn"
                          v-text="$ml.get('activate')"
                        >
                          Ativar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <transition v-else name="fade">
              <div class="row" v-if="codesRecovery.length">
                <div class="col-24">
                  <hr />
                  <h6 v-text="$ml.get('storeYourBackupCodes')">
                    Armazene seus códigos de backup
                  </h6>
                  <label v-text="$ml.get('labelCodeBackup2faLocker')">
                    Após realizar o download do código de backup, não será
                    possível gerar novos códigos. Por isso, certifique-se de
                    armazená-lo em um local seguro.
                  </label>
                </div>
                <div class="col-24">
                  <div class="row">
                    <div
                      v-for="(item, index) in codesRecovery"
                      :key="index"
                      class="form-group col-7 mr-2"
                    >
                      <input
                        class="form-control"
                        disabled
                        type="text"
                        :value="item"
                      />
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="form-group">
                      <!-- <button class="btn" @click="generateKeys()">
                        <Spinner v-show="loadingBtn" />
                        <font
                          v-show="!loadingBtn"
                          v-text="$ml.get('generateNewCodes')"
                        >
                          Gerar novos códigos</font
                        >
                      </button> -->
                      <button
                        @click="downloadCSVData()"
                        v-if="codesRecovery.length"
                        class="btn ml-2"
                        :disabled="loadingBtn"
                      >
                        <img
                          src="../../../src/assets/icons/download-white.svg"
                          width="16"
                          height="16"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="card mb-3 col-24">
          <div class="card-header" id="optionCardHeaderSafe">
            <h6 class="m-0 p-0 light" v-text="$ml.get('password')">Senha</h6>
          </div>
          <div class="card-body p-0 px-3 mt-3 col-24">
            <div>
              <div class="col-24" style="gap: 10px; flex-wrap: wrap">
                <div
                  v-show="invalidCredentials"
                  class="alert alert-warning text-center"
                >
                  <span v-text="$ml.get('tryAgain')"
                    >Por favor, revise os dados fornecidos e tente
                    novamente.</span
                  >
                </div>
                <div class="form-group">
                  <label class="text-muted">{{ safePasswordInputLabel }}</label>
                  <input
                    :style="{
                      border: errorSafePassword ? '1px solid red' : '',
                    }"
                    type="password"
                    class="form-control col-24"
                    v-model="password"
                    :placeholder="$ml.get('strongPassword')"
                    maxlength="200"
                  />
                  <transition v-if="userError" name="fade">
                    <label class="lblError">{{
                      passwordValidation.errorsString
                    }}</label>
                  </transition>
                </div>
                <div class="form-group mt-3">
                  <label
                    class="text-muted"
                    v-text="$ml.get('confirmPasswordLocker')"
                    >Confirmar senha</label
                  >
                  <input
                    type="password"
                    class="form-control col-24"
                    v-model="passwordConfirm"
                    :placeholder="$ml.get('confirmYourPassword')"
                    maxlength="200"
                  />
                  <transition name="fade">
                    <label
                      class="lblError"
                      v-if="userError && !$v.passwordConfirm.required"
                      v-text="$ml.get('enterPasswordConfirmation')"
                      >Digite a confirmação de senha</label
                    >
                    <label
                      class="lblError"
                      v-if="userError && !$v.passwordConfirm.sameAsPassword"
                      v-text="$ml.get('passwordsMustMatch')"
                      >As senhas devem ser iguais!</label
                    >
                  </transition>
                </div>
                <div
                  class="form-group"
                  v-if="
                    getUserType === 'hacker' &&
                    checkboxSMSCodeRequired &&
                    showRegisterPassword
                  "
                >
                  <label class="text-muted" v-text="$ml.get('useCodeSms')"
                    >Use o código recebido por SMS</label
                  >
                  <the-mask
                    class="form-control"
                    v-model="codeSmsChangePassword"
                    :mask="['### ###']"
                    :placeholder="$ml.get('enterTheCode')"
                  />
                  <div class="col-12">
                    <label
                      v-if="!errorAwaitNewRequest"
                      style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                      @click="sendCodeSms"
                      >{{
                        timeLeftSms > 0
                          ? `${$ml.get(
                              "requestNewCodeEmail",
                            )} ${formattedTimeSMS}`
                          : $ml.get("receiveCode")
                      }}</label
                    >
                    <label v-else class="lblError" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>

                  </div>
                </div>
                <div
                  class="form-group"
                  v-if="
                    getUserType === 'company' &&
                    checkboxSMSCodeRequired &&
                    showRegisterPassword &&
                    lockerStatus
                  "
                >
                  <label class="text-muted" v-text="$ml.get('useCodeSms')"
                    >Use o código recebido por SMS</label
                  >
                  <the-mask
                    class="form-control"
                    v-model="codeSmsChangePassword"
                    :mask="['### ###']"
                    :placeholder="$ml.get('enterTheCode')"
                  />
                  <div class="col-12">
                    <label
                      v-if="!errorAwaitNewRequest"
                      style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                      @click="sendCodeSms"
                      >{{
                        timeLeftSms > 0
                          ? `${$ml.get(
                              "requestNewCodeEmail",
                            )} ${formattedTimeSMS}`
                          : $ml.get("receiveCode")
                      }}</label
                    >
                    <label v-else class="lblError" style="position:relative;" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>

                  </div>
                </div>
                <div class="form-group" v-if="getUserType === 'hacker'">
                  <label class="text-muted" v-text="$ml.get('useCodeEmail')"
                    >Use o código recebido por email</label
                  >
                  <the-mask
                    class="form-control"
                    v-model="codeEmailPassword"
                    :mask="['### ###']"
                    :placeholder="$ml.get('enterTheCode')"
                  />
                  <div class="col-12">
                    <label
                      v-if="!errorAwaitNewRequest"
                      style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                      @click="sendCodeEmail"
                      >{{
                        timeLeftEmail > 0
                          ? `${$ml.get(
                              "requestNewCodeEmail",
                            )} ${formattedTimeEmail}`
                          : $ml.get("receiveCode")
                      }}</label
                    >
                    <label v-else class="lblError" style="position:relative;" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>
                  </div>
                </div>
                <div class="form-group" v-if="getUserType === 'company'">
                  <label class="text-muted" v-text="$ml.get('useCodeEmail')"
                    >Use o código recebido por email</label
                  >
                  <the-mask
                    class="form-control"
                    v-model="codeEmailPassword"
                    :mask="['### ###']"
                    :placeholder="$ml.get('enterTheCode')"
                  />
                  <div class="col-12">
                    <label
                      v-if="!errorAwaitNewRequestEmail"
                      style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                      @click="sendCodeEmail"
                      >{{
                        timeLeftEmail > 0
                          ? `${$ml.get(
                              "requestNewCodeEmail",
                            )} ${formattedTimeEmail}`
                          : $ml.get("receiveCode")
                      }}</label
                    >
                    <label v-else class="lblError" style="position:relative;" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>
                  </div>
                </div>
                <div
                  class="form-group"
                  v-if="
                    getUserType === 'hacker' &&
                    checkboxCodeRequired &&
                    showRegisterPassword
                  "
                >
                  <label
                    class="text-muted"
                    v-text="$ml.get('useYourAuthenticationAppToEnterTheCode')"
                    >Use seu aplicativo de autenticação para inserir o
                    código</label
                  >
                  <the-mask
                    :style="{ border: errorCode2fa ? '1px solid red' : '' }"
                    class="form-control"
                    v-model="code2fa"
                    :mask="['### ###']"
                    :placeholder="$ml.get('enterTheCode')"
                  />
                </div>
                <div
                  class="form-group"
                  v-if="
                    getUserType === 'company' &&
                    checkboxCodeRequired &&
                    showRegisterPassword &&
                    lockerStatus
                  "
                >
                  <label
                    class="text-muted"
                    v-text="$ml.get('useYourAuthenticationAppToEnterTheCode')"
                    >Use seu aplicativo de autenticação para inserir o
                    código</label
                  >
                  <the-mask
                    :style="{ border: errorCode2fa ? '1px solid red' : '' }"
                    class="form-control"
                    v-model="code2fa"
                    :mask="['### ###']"
                    :placeholder="$ml.get('enterTheCode')"
                  />
                </div>
                <button
                  class="btn mb-2"
                  :disabled="!password || !passwordConfirm"
                  @click="registerPasswordSafe"
                  v-text="$ml.get('save')"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="menuItem === 'config'">
        <div v-if="getUserRole === 'owner'" class="card mb-3">
          <div class="card-header">
            <h6 class="m-0 p-0 light">
              {{ $ml.get("menuLocker") }}
            </h6>
          </div>
          <div class="card-body p-0 px-3 mt-3 form-group col-24">
            <div
              class="col-24 d-flex justify-content-between align-items-center"
            >
              <div class="d-flex" style="gap: 10px">
                <p style="font-weight: 500" class="m-0">
                  {{ $ml.get("enableReportVault") }}
                  <VueCustomTooltip :label="$ml.get('tooltipLocker')" :multiline="true" size="is-large">
                    <svg width="16" height="16" class="ml-2">
                      <image
                        xlink:href="../../../src/assets/svg/info-fill.svg"
                        width="16"
                        height="16"
                      />
                    </svg>
                  </VueCustomTooltip>
                </p>
              </div>
              <label class="switch mb-0 mr-2">
                <input
                  type="checkbox"
                  v-model="lockerStatus"
                  v-b-modal.modal-email-token
                  :disabled="loadingAuthenticationMethods"
                  @click.prevent="
                    (typeActionLocker = 'activeLocker'),
                      (showModalConfirmEmailToken = true),
                      (status = lockerStatus)
                  "
                />
                <span class="slider round"></span>
              </label>
            </div>           
          </div>
        </div>
        <div class="card">
          <div class="card-header"> 
             <h6 class="m-0 p-0 light">
              {{ $ml.get('authenticationControls') }}
            </h6>
          </div>
          <div class="card-body p-0 px-3 mt-3 form-group col-24">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <p style="font-weight: 500" class="m-0">
                  Two-factor authentication
                </p>
                <label
                  class="m-0 lbl-info-methods"
                  v-text="$ml.get('methodAppToken')"
                  >Proteja o acesso ao cofre recebendo o código via app.</label
                >
              </div>
              <label class="switch mb-0 mr-2">
                <input
                  type="checkbox"
                  :checked="checkboxCodeRequired"
                  :disabled="loadingAuthenticationMethods"
                  v-b-modal.modal-email-token
                  @click.prevent="updateAuth('appToken')"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <hr />
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <p
                  style="font-weight: 500"
                  class="m-0"
                  v-text="$ml.get('receiveCodeBySms')"
                >
                  Receber código por SMS
                </p>
                <label
                  class="m-0 lbl-info-methods"
                  v-text="$ml.get('methodAppSms')"
                  >Proteja o acesso ao cofre recebendo o código por SMS.</label
                >
              </div>
              <label class="switch mb-0 mr-2">
                <input
                  type="checkbox"
                  :checked="checkboxSMSCodeRequired"
                  v-b-modal.modal-email-token
                  @click.prevent="updateAuth('smsToken')"
                  :disabled="loadingAuthenticationMethods"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <hr />
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <p
                  style="font-weight: 500"
                  class="m-0"
                  v-text="$ml.get('titleEmailTwoAuthentication')"
                >
                  Two-factor authentication (2FA) via Email
                </p>
                <label
                  class="m-0 lbl-info-methods"
                  v-text="$ml.get('methodAppEmail')"
                  >Proteja o acesso ao cofre recebendo o código por
                  e-mail.</label
                >
              </div>
              <label class="switch mb-0 mr-2">
                <input
                  type="checkbox"
                  :checked="checkboxEmailCodeRequired"
                  :disabled="loadingAuthenticationMethods"
                  v-b-modal.modal-email-token
                  @click.prevent="updateAuth('emailToken')"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- Histórico de acessos-->

      <div v-if="menuItem === 'access'">
        <div class="col-24 mb-3">
          <div
            class="col-24 mb-3 input-group"
            v-if="$store.getters['getUserRole'] === 'owner'"
          >
            <multiselect
              v-model="userSelected"
              :options="listMembers"
              label="email"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              :placeholder="$ml.get('selectUser')"
            >
            </multiselect>
          </div>
          <div class="col-24 d-md-flex justify-content-between">
            <div class="col-md-11 col input-group mb-3 m-md-0">
              <multiselect
                v-model="eventSelected"
                :options="listEventsLocker"
                label="event"
                :searchable="true"
                :custom-label="nameLang"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="$ml.get('selectEvent')"
              >
              </multiselect>
            </div>

            <div class="col-md-6 col input-group mb-3 m-md-0">
              <b-form-datepicker
                class="datepicker m-0 p-0"
                label-help=""
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                :locale="$ml.get('ln')"
                today-button
                reset-button
                close-button
                :label-today-button="$ml.get('today')"
                :label-reset-button="$ml.get('reset')"
                :label-close-button="$ml.get('exit')"
                v-model="initialDate"
                :max="minAccessDate"
                :placeholder="$ml.get('start')"
              >
              </b-form-datepicker>
            </div>
            <div class="col-md-6 col input-group">
              <b-form-datepicker
                class="datepicker m-0 p-0"
                label-help=""
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                :locale="$ml.get('ln')"
                today-button
                reset-button
                close-button
                :label-today-button="$ml.get('today')"
                :label-reset-button="$ml.get('reset')"
                :label-close-button="$ml.get('exit')"
                :min="initialDate"
                :max="minAccessDate"
                v-model="finalDate"
                :disabled="initialDate == null"
                :placeholder="$ml.get('end')"
              >
              </b-form-datepicker>
            </div>
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-header">
            <h6 class="m-0 p-0 light" v-text="$ml.get('historic')">
              Histórico
            </h6>
          </div>
          <div class="card-body p-0">
            <table>
              <tbody>
                <tr v-show="!itensSessions.length" class="loading">
                  <div v-if="loading" class="c-loader m-3"></div>
                  <h6
                    v-else
                    class="col d-flex justify-content-center p-3"
                    v-text="$ml.get('noRegisterAvailable')"
                  >
                    Nenhum registro disponível
                  </h6>
                </tr>
                <tr v-for="(item, index) in itensSessions" :key="index">
                  <td
                    class="col-2 justify-content-center d-flex align-items-start"
                  >
                    <svg width="20" height="20" class="mt-1">
                      <image
                        xlink:href="../../../src/assets/icons/tv.svg"
                        width="20"
                        height="20"
                      />
                    </svg>
                  </td>
                  <td class="col-22">
                    <p class="mb-0">
                      <strong>IP address: <font v-text="item.ip"></font></strong
                      ><br />
                      <!-- User agent: <font v-text="item.browser_agent"></font><br /> -->
                      {{ $ml.get("event") }}:
                      <font v-text="$ml.get(item.event_type)"></font><br />
                      <font v-show="item.report_title"
                        >Relatório: {{ item.report_title }}</font
                      ><br v-show="item.report_title" />
                      Location:
                      <font v-if="item.location" v-text="item.location"></font
                      ><br />
                      Signed in: <font v-text="item.createdAt"></font><br />
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-show="totalPages > 10 && !loading">
          <b-pagination
            v-model="pageActive"
            :total-rows="totalPages"
            :per-page="10"
            :prev-text="$ml.get('previous')"
            :next-text="$ml.get('next')"
            align="right"
          >
          </b-pagination>
        </div>
      </div>
    </div>
    <DisableAuthModal
      v-model="showDisableAuthModal"
      @update:setRecaptchaToken="setRecaptchaToken"
      @update:codeInput="updateCodeInput"
      @update:codeEmail="updateCodeEmail"
      @disableAuth="disableAuth"
      :modal-data="modalData"
      ref="disableAuthModal"
    />
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import Swal from "sweetalert2";
import { minLength, required, sameAs } from "vuelidate/lib/validators";
import Onboarding from "../../components/Onboarding.vue";
import RecaptchaV2 from "../../components/recaptchaV2.vue";
import {
  default as AccountService,
  default as accountService,
} from "../../services/account.service";
import companyService from "../../services/company.service";
import {
  default as LockerService,
  default as lockerService,
} from "../../services/locker.service";
import ModalConfirmEmailToken from "../modais/ModalConfirmEmailToken.vue";
import PasswordConfirmationActivationModal from "../modais/PasswordConfirmationActivationModal.vue";
import DisableAuthModal from "./DisableAuthModal.vue";
export default {
  name: "Locker",
  components: {
    RecaptchaV2,
    DisableAuthModal,
    PasswordConfirmationActivationModal,
    Onboarding,
    ModalConfirmEmailToken,
  },
  data() {
    return {
      telephoneActive: true,
      desc: "",
      phone: {
        countryCode: "",
        number: "",
        isValid: false,
      },
      msgPhoneInvalid: "",
      codeSms: "",
      code2fa: "",
      codeTwoFactor: "",
      phone_hash: "",
      phoneValidate: false,
      authentication2Fa: false,
      showInputPhone: false,
      showInputSms: false,
      showQrcode: false,

      validError: false,
      submitStatus: false,

      loading: true,
      loadingBtn: false,
      loading2fa: false,

      qrCode: null,

      codesRecovery: [],
      recovery_keys: 5,

      function: "changeDados",

      tokenRecaptcha: "",
      showDisableAuthModal: false,
      disable2faCode: "",
      modalData: {
        title: "",
        description: "",
        type: "",
      },

      actionType: "",
      twoFactoryAuthentication: false,
      getUserType: "",
      password: "",
      passwordConfirm: "",
      codeEmail: "",
      errorCode2faSafe: false,
      errorCodeEmail: false,
      errorSafePassword: false,
      invalidCredentials: false,
      userError: false,
      emailCodeRequired: false,
      showGif: false,
      showRegisterPassword: false,
      rules: [
        { message: "aNumber", regex: /[0-9]+/ },
        { message: "anUppercaseLetter", regex: /[A-Z]+/ },
        { message: "aLowercaseLetter", regex: /[a-z]+/ },
        { message: "atLeastCharacters", regex: /.{6,}/ },
      ],
      timeLeft: 0,

      getUserRole: "",
      lockerStatus: false,
      menuItem: "credential",
      itensSessions: [],
      initialDate: null,
      finalDate: null,
      userSelected: "",
      listMembers: [],
      eventSelected: {},
      listEventsLocker: [
        {
          event: "all",
        },
        {
          event: "USER_LOGIN",
        },
        {
          event: "REPORT_MOVED_TO_LOCKER",
        },
        {
          event: "REPORT_MOVED_OUT_OF_LOCKER",
        },
        {
          event: "REPORT_ACCESS",
        },
        {
          event: "USER_LOGIN_FAILED",
        },
      ],
      isTwoFactorAuthenticationEnabled: false,
      checkboxCodeRequired: false,
      checkboxSMSCodeRequired: false,
      checkboxEmailCodeRequired: false,

      codeSmsChangePassword: "",
      timeLeftSms: "",
      formattedTimeSMS: 0,
      errorCode2fa: false,
      timeLeftEmail: 0,
      formattedTimeEmail: "",
      hasPhone: "",
      pageActive: 1,
      totalPages: 1,
      typeActionLocker: "",
      codeEmailPassword: "",
      showModalConfirmEmailToken: false,
      loadingInactiveLocker: false,
      loadingAuthenticationMethods: false,
      status: "",
      translations: {
        countrySelectorLabel: this.$ml.get("countrySelectorLabel"),
        phoneNumberLabel: this.$ml.get("phoneNumberLabel"),
        example: this.$ml.get("examplePhone"),
        },
      ssoIsActive: false,
      errorAwaitNewRequest: false,
      errorAwaitNewRequestEmail: false,
    };
  },
  validations: {
    codeSms: { required, minLength: minLength(6) },
    code2fa: { required, minLength: minLength(6) },
    codeTwoFactor: { required, minLength: minLength(6) },
    passwordConfirm: {
      required,
      sameAsPassword: sameAs("password"),
    },
  },

  mounted() {
    this.eventSelected.event = "all";
    this.getUserType = this.$store.getters["getUserType"];
    this.getUserRole = this.$store.getters["getUserRole"];

    if(this.getUserType === 'company'){
      this.listEventsLocker = [
        {
          event: "all",
        },
        {
          event: "LOCKER_ACTIVATED",
        },
        {
          event: "LOCKER_DEACTIVATED",
        },
        {
          event: "USER_LOGIN",
        },
        {
          event: "REPORT_MOVED_TO_LOCKER",
        },
        {
          event: "REPORT_MOVED_OUT_OF_LOCKER",
        },
        {
          event: "REPORT_ACCESS",
        },
        {
          event: "USER_LOGIN_FAILED",
        }
      ]
    }

    this.getAccount();
    this.$v.$reset();
    this.changeDados();
  },
  watch: {
    menuItem() {
      if (this.menuItem === "access") {
        this.getAccess();
        if (this.$store.getters["getUserRole"] === "owner") {
          this.getMembers();
        }
      }
    },
    pageActive() {
      this.getAccess();
    },
    userSelected() {
      this.getAccess();
    },
    eventSelected() {
      this.getAccess();
    },
    initialDate() {
      this.validateDate();
    },
    finalDate() {
      this.validateDate();
    },
    codeEmail() {
      this.errorCodeEmail = false;
    },
    password() {
      this.errorSafePassword = false;
    },
  },
  computed: {
    passwordValidation() {
      const errors = [];

      for (let condition of this.rules) {
        if (!condition.regex.test(this.password)) {
          errors.push(this.$ml.get(condition.message));
        }
      }
      let errorsString = "";

      if (errors.length) {
        errorsString = `${this.$ml.get("thePasswordMustHave")}, ${errors.join(
          ", ",
        )}`;
      } else {
        errorsString = "";
      }

      return { errorsString };
    },
    safePasswordInputLabel() {
      return this.showRegisterPassword
        ? this.$ml.get("resetPasswordLocker")
        : this.$ml.get("registerPasswordLocker");
    },
    minAccessDate() {
      const now = moment();
      let today = moment(now, "DD/MM/YYYY").format("YYYY-MM-DD");
      return today;
    },
  },
  methods: {
    waitAPI: _.debounce(function (action) {
      this.updateAuthenticationMethods(action);
    }, 500),

    validateDate() {
      const dateInicio = moment(this.initialDate);
      const dateFinal = moment(this.finalDate);

      if (dateFinal.isBefore(dateInicio)) {
        Swal.fire({
          icon: "warning",
          title: this.$ml.get("swalWarningDateText"),
          text: this.$ml.get("swalWarningDateTitle"),
          confirmButtonText: this.$ml.get("undestand"),
          confirmButtonColor: "#3085d6",
        });
        return;
      }
      if (this.initialDate && this.finalDate) this.getAccess();
    },
    updateAuth(action) {
      switch (action) {
        case "appToken":
          if (this.checkboxCodeRequired) {
            this.showModalConfirmEmailToken = true;
            this.typeActionLocker = action;
            return;
          }
          this.waitAPI(action);
          break;
        case "emailToken":
          if (this.checkboxEmailCodeRequired) {
            this.showModalConfirmEmailToken = true;
            this.typeActionLocker = action;
            return;
          }
          this.waitAPI(action);
          break;
        case "smsToken":
          if (this.checkboxSMSCodeRequired) {
            this.showModalConfirmEmailToken = true;
            this.typeActionLocker = action;
            return;
          }
          this.waitAPI(action);
          break;
        default:
          console.log("Método não encontrado!");
      }
    },
    getCredentials(credentials) {
      if (this.typeActionLocker === "activeLocker") {
        this.toogleSafeReport(credentials);
        return;
      }
      this.updateAuthenticationMethods(this.typeActionLocker, credentials);
    },
    nameLang({ event }) {
      return `${this.$ml.get(event)}`;
    },
    async getMembers() {
      try {
        const { data } = await companyService.getMembers();
        const { company_members } = data;
        this.listMembers = company_members;
      } catch (error) {
        console.log(error);
      }
    },
    async getAccess() {
      this.loading = true;

      try {
        const pageSize = 10;
        let payload = "";

        if (this.userSelected.personId) {
          payload += `&user=${this.userSelected.personId}`;
        }

        if (this.finalDate) {
          payload += `&initial_date=${this.initialDate}&final_date=${this.finalDate}`;
        }

        if (this.eventSelected.event !== "all") {
          payload += `&event_type=${this.eventSelected.event}`;
        }

        const { data } = await lockerService.getAccessLocker(
          this.pageActive,
          pageSize,
          payload,
        );

        this.itensSessions = data.items;
        this.totalPages = data.total;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (error.response.data.message && this.menuItem != "config") {
          Swal.fire({
            icon: "warning",
            title: this.$ml.get("manyRequestTitle"),
            text: this.$ml.get("manyRequestText"),
            confirmButtonText: this.$ml.get("undestand"),
            timer: 5000,
          });
        }
      }
    },
    async sendCodeEmail() {
      this.errorAwaitNewRequestEmail = false;
      if (this.timeLeftEmail > 0) return;

      const newCodeRequest = 300;
      this.timeLeftEmail = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftEmail > 0) {
          this.timeLeftEmail--;

          const minutes = Math.floor(this.timeLeftEmail / 60);
          const seconds = this.timeLeftEmail % 60;

          this.formattedTimeEmail = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
          this.errorAwaitNewRequestEmail = false;
        }
      }, 1000);

      try {
        const { status } = await LockerService.getTokenEmailLocker();

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error.response);
        if (
          error.response.data.message ===
          "Aguarde 5 minutos para receber outro token"
        ) {
          this.errorAwaitNewRequestEmail = true;
        }
      }
    },
    async sendCodeSms() {
      this.errorAwaitNewRequest = false;
      if (!this.hasPhone) {
        this.$refs.refOnboarding.onboardingRegisterPhone();
        return;
      }
      if (this.timeLeftSms > 0) return;

      const newCodeRequest = 300;
      this.timeLeftSms = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftSms > 0) {
          this.timeLeftSms--;

          const minutes = Math.floor(this.timeLeftSms / 60);
          const seconds = this.timeLeftSms % 60;

          this.formattedTimeSMS = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
          this.errorAwaitNewRequest = false;
        }
      }, 1000);

      try {
        const { status } = await LockerService.getTokenSmsLocker();

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error.response);
        if (
          error.response.data.message === "Telefone não cadastrado ou inativo"
        ) {
          Swal.fire({
            icon: "warning",
            title: this.$ml.get("phoneNotRegistered"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        if (
          error.response.data.message ===
          "Aguarde 5 minutos para receber outro token"
        ) {
          this.errorAwaitNewRequest = true;
        }
      }
    },
    async sendCodeSmsAccount() {
      if (this.timeLeftSms > 0) return;

      const newCodeRequest = 300;
      this.timeLeftSms = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftSms > 0) {
          this.timeLeftSms--;

          const minutes = Math.floor(this.timeLeftSms / 60);
          const seconds = this.timeLeftSms % 60;

          this.formattedTimeSMS = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
        }
      }, 1000);
      try {
        const { status } = await AccountService.getTokenSms();

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error.response);
        if (
          error.response.data.message === "Telefone não cadastrado ou inativo"
        ) {
          Swal.fire({
            icon: "warning",
            title: this.$ml.get("phoneNotRegistered"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        if (
          error.response.data.message ===
          "Aguarde 5 minutos para receber outro token"
        ) {
          Swal.fire({
            icon: "warning",
            title: this.$ml.get("waitToRequestNewToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      }
    },
    async updateAuthenticationMethods(action, credentials) {
      this.loadingAuthenticationMethods = true;      
      const self = this;
      try {
        const payload = {
          isTwoFactorAuthenticationEnabled: this.checkboxCodeRequired,
          isEmailCodeRequired: this.checkboxEmailCodeRequired,
          isSMSCodeRequired: this.checkboxSMSCodeRequired,
        };
        if (credentials != undefined) {
          if(this.ssoIsActive){
            payload.lockerEmailToken = Number(credentials.emailToken);
          }
          if(!this.ssoIsActive){
            payload.password = credentials.password ?? "";
          }
          this.$refs.modalEmailToken.loadingBtn = true;
        }

        switch (action) {
          case "appToken":
            payload.isTwoFactorAuthenticationEnabled =
              !this.checkboxCodeRequired;
            break;

          case "emailToken":
            payload.isEmailCodeRequired = !this.checkboxEmailCodeRequired;
            break;

          case "smsToken":
            payload.isSMSCodeRequired = !this.checkboxSMSCodeRequired;
            break;

          default:
            break;
        }

        const { status } = await lockerService.putAuthenticationMethods(
          payload,
        );
        const statusCodeSuccess = 200;

        if (status === statusCodeSuccess) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("updateConfigLocker"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 10000,
          });
          self.getAccount();
          self.loadingAuthenticationMethods = false;
          self.showModalConfirmEmailToken = false;
        }
        if (credentials != undefined) {
          self.$refs.modalEmailToken.loadingBtn = false;
        }

      } catch (error) {
        self.loadingAuthenticationMethods = false;
        if (credentials != undefined) {
          self.$refs.modalEmailToken.loadingBtn = false;
        }
        console.log(
          `>>>>>> Erro ao atualizar os métodos de autenticação <<<<<`,
        );
        console.log(error);

        self.showModalConfirmEmailToken = true;

        if(this.ssoIsActive){
          setTimeout(() => {
          self.$refs.modalEmailToken.errorCodeEmail = true;
        }, 500);      
          return;
        }

        self.$refs.modalEmailToken.errorCredentials = true;
      }
    },
    async getAccount() {
      this.showQrcode = false;
      try {
        const { data } = await accountService.getAccountMy();
        const {
          status,
          isTwoFactorAuthenticationEnabled,
          lockerPassword,
          is2faCodeRequired,
          isSMSCodeRequired,
          isEmailCodeRequired,
          activePhone,
        } = data.lockerSettings;
        this.authentication2Fa = isTwoFactorAuthenticationEnabled;
        this.showRegisterPassword = lockerPassword;
        this.checkboxSMSCodeRequired = isSMSCodeRequired;
        this.checkboxCodeRequired = is2faCodeRequired;
        this.checkboxEmailCodeRequired = isEmailCodeRequired;
        this.lockerStatus = status === "active" ? true : false;
        this.hasPhone = activePhone;
        this.$store.dispatch("setUser", {
          lockerSettings: data.lockerSettings,
        });
        if (isTwoFactorAuthenticationEnabled) {
          this.showQrcode = true;
        }

        if(this.getUserType === 'company'){
           const {enabled} = data.ssoSettings;
            this.ssoIsActive = enabled;
         } 

      } catch (error) {
        console.log(error);
      }
    },
    nameFilter({ name }) {
      return `${this.$ml.get(name)}`;
    },

    async toogleSafeReport(credenciais) {
      this.$refs.modalEmailToken.loadingBtn = true;
      if (this.lockerStatus) {
        this.loadingInactiveLocker = true;
        Swal.fire({
          title: this.$ml.get("waitRequestTitle"),
          text: this.$ml.get("waitRequestText"),
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
      }
      try {
        const { status } = await lockerService.putLocker({
          lockerEmailToken: Number(credenciais.emailToken),
        });
        const statusCodeSuccess = 200;

        if (status === statusCodeSuccess) {
          this.$refs.modalEmailToken.codeEmail = "";
          this.$refs.modalEmailToken.errorCodeEmail = false;
          this.$refs.modalEmailToken.password = "";
          this.$refs.modalEmailToken.errorPassword = "";
          this.showModalConfirmEmailToken = false;
          this.getAccount();

          if (!this.lockerStatus) {
            Swal.fire({
              title: this.$ml.get("menuLocker"),
              text: this.$ml.get("swalActiveLocker"),
              icon: "success",
              timer: 5000,
              showConfirmButton: false,
            });
          }
          if (this.lockerStatus) {
            this.loadingInactiveLocker = false;
            Swal.fire({
              title: this.$ml.get("menuLocker"),
              text: this.$ml.get("swalInactiveLocker"),
              icon: "success",
              timer: 5000,
              showConfirmButton: false,
            });
          }
        }
        this.$refs.modalEmailToken.loadingBtn = false;
      } catch {
        Swal.close();
        if (this.statusLocker) {
          this.loadingInactiveLocker = false;
        }
        this.$refs.modalEmailToken.loadingBtn = false;
        setTimeout(() => {
          this.$refs.modalEmailToken.errorCodeEmail = true;
          this.$bvModal.show("modal-email-token");
        }, 500);
      }
    },
    configPasswordSafe() {
      this.showRegisterPassword = true;
    },

    async registerPasswordSafe() {
      this.errorCodeEmail = false;
      this.errorCode2faSafe = false;
      this.invalidCredentials = false;
      this.userError = false;

      this.$v.$touch();
      if (
        this.$v.passwordConfirm.$invalid ||
        this.passwordValidation.errorsString
      ) {
        console.log("Error");
        this.userError = true;
        return;
      }

      try {
        const payload = {
          password: this.password,
          lockerEmailToken: Number(this.codeEmailPassword),
        };
        if (this.checkboxSMSCodeRequired) {
          payload.lockerSmsToken = Number(this.codeSmsChangePassword);
        }
        if (this.checkboxCodeRequired) {
          payload.lockerAppToken = this.code2fa;
        }

        const { status } = await AccountService.putPasswordSafe(payload);
        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.showRegisterPassword
              ? this.$ml.get("passwordChanged")
              : this.$ml.get("swalRegisterPassword"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });

          this.passwordConfirm = "";
          this.password = "";
          this.code2fa = "";
          this.codeSmsChangePassword = "";
          this.codeEmailPassword = "";
          this.timeLeftSms = 0;
          this.timeLeftEmail = 0;
          this.changeDados();
          this.getAccount();
        }
      } catch (error) {
        console.log(error.response.data.message);
        if (error.response.data.message === "Operação não permitida") {
          this.invalidCredentials = true;
          return;
        }
        if (
          error.response.data.message ===
          "As credenciais do cofre não são válidas."
        ) {
          this.invalidCredentials = true;
          return;
        }
        if (
          error.response.data.message ===
          "As credenciais do cofre não são válidas!"
        ) {
          this.invalidCredentials = true;
          return;
        }
        if (
          error.response.data.message[0] ===
          "O email_token informado não é válido!"
        ) {
          this.errorCodeEmail = true;
          return;
        }
        if (
          error.response.data.message[0] ===
          "A senha deve conter no mínimo 6 caracteres e no máximo 200 caracteres!"
        ) {
          this.errorSafePassword = true;
          return;
        }
      }
    },
    featureActivationAction(type) {
      this.actionType = type;
    },

    // execute the recaptcha widget
    executeRecaptcha(change) {
      this.function = change;

      this.getToken(this.tokenRecaptcha);
    },

    getToken(token) {
      switch (this.function) {
        case "sendSms":
          this.sendSms(token);
          break;
        case "activePhone":
          this.activePhone();
          break;
        case "active2fa":
          this.active2fa(token);
          break;
        case "show2fa":
          this.show2fa();
          break;
        case "inactivePhone":
          this.inactivePhone();
          break;

        default:
          break;
      }
    },

    async changeDados() {
      this.tokenRecaptcha = "";
      (this.phoneValidate = false),
        (this.showInputPhone = false),
        (this.showInputSms = false),
        (this.showQrcode = false),
        (this.phone_hash = "");
      (this.desc = ""),
        AccountService.getAuthentication().then(
          (response) => {
            this.loading = false;
            if (response.data.phone_status == "active") {
              this.phoneValidate = true;
            }
            if (response.data.phone) {
              this.phone_hash = response.data.phone;
            }
          },
          () => {
            this.loading = false;
          },
        );
    },

    savePhone() {
      if (!this.phoneValidate) {
        setTimeout(() => {
          this.showInputPhone = true;
        }, 200);
      } else {
        this.executeRecaptcha("inactivePhone");
      }
    },

    updatePhoneNumber(number) {
      this.phone = {
        countryCode: number.countryCallingCode,
        number: number.nationalNumber,
        isValid: number.isValid,
      };
    },

    sendSms(tokenRecaptcha) {
      var self = this;

      if (!this.phone.isValid) {
        this.msgPhoneInvalid = true;
        return;
      }

      this.msgPhoneInvalid = false;
      this.loadingBtn = true;

      AccountService.postPhoneValidation({
        countryCode: this.phone.countryCode,
        number: this.phone.number,
        tokenRecaptcha: tokenRecaptcha,
      }).then(
        () => {
          this.loadingBtn = false;
          this.showInputSms = true;
          this.showInputPhone = false;

          Swal.fire({
            icon: "success",
            title: self.$ml.get("smsCodeSent"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          this.codeSms = "";
        },
        () => {
          this.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          self.loadingBtn = false;
        },
      );
    },

    activePhone() {
      var self = this;

      if (this.$v.codeSms.$invalid) {
        this.validError = true;
        return;
      }

      this.validError = false;
      this.loadingBtn = true;

      AccountService.postPhoneValidationCode({
        validate_code: this.codeSms,
        tokenRecaptcha: this.tokenRecaptcha,
      }).then(
        () => {
          this.loadingBtn = false;
          this.showInputSms = false;
          this.phoneValidate = true;
          Swal.fire({
            icon: "success",
            title: self.$ml.get("validatedPhone"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.tokenRecaptcha = "";
          this.codeSms = "";
          this.changeDados();
          this.getAccount();
        },
        () => {
          this.$refs.recaptchaPhone.resetRecaptcha();
          this.tokenRecaptcha = "";
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("invalidCode"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.loadingBtn = false;
        },
      );
    },

    updateCodeInput(value) {
      this.disable2faCode = value;
    },

    updateCodeEmail(value) {
      this.codeEmail = value;
    },

    setDisablePhoneModalData() {
      this.modalData = {
        title: this.$ml.get("doYouWantToRemoveThePhone"),
        description: this.$ml.get("dataWillBeRemovedWithPhoneValidation"),
        type: "phone",
      };
    },

    inactivePhone() {
      this.setDisablePhoneModalData();

      this.showDisableAuthModal = true;
    },

    async disablePhoneValidation() {
      const sanitizedInputCode = String(this.disable2faCode.trim());

      try {
        this.$refs.disableAuthModal.credentialsError = false;
        await AccountService.deletePhone({
          password: sanitizedInputCode,
          tokenRecaptcha: this.tokenRecaptcha,
          email_token: Number(this.codeEmail),
        });

        this.showDisableAuthModal = false;

        Swal.fire({
          icon: "success",
          title: this.$ml.get("phoneSuccessfullyRemoved"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

        await this.changeDados();
        this.getAccount();
      } catch (error) {
        this.loading2fa = false;
        this.showDisableAuthModal = true;
        this.$refs.disableAuthModal.credentialsError = true;
        Swal.fire({
            icon: "warning",
            title: this.$ml.get("tryAgain"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
      }
    },

    setDisable2faModalData() {
      this.modalData = {
        title: this.$ml.get("doYouReallyWantToRemoveTwoFactor"),
        description: this.$ml.get("toDoThisYouNeedToEnterYourAppCode"),
        type: "2fa_locker",
      };
    },

    async show2fa() {
      if (!this.phoneValidate) {
        this.$refs.refOnboarding.onboardingRegisterPhone();
        return;
      }

      if (this.authentication2Fa) {
        this.setDisable2faModalData();

        this.showDisableAuthModal = true;
      } else {
        this.loading2fa = true;
        this.qrCode = null;
        LockerService.get2faLocker().then(
          async (response) => {
            this.loading2fa = false;
            this.showQrcode = true;
            this.qrCode = response.data;
          },
          () => {
            this.loading2fa = false;
          },
        );
      }
    },

    async disable2faAuth() {
      const sanitizedInputCode = String(this.disable2faCode.trim());

      const code2fa = {
        code: sanitizedInputCode,
        recoveryKey: sanitizedInputCode,
        tokenRecaptcha: this.tokenRecaptcha,
        lockerEmailToken: Number(this.codeEmail),
      };

      if (sanitizedInputCode.length > 6) {
        delete code2fa.code;
      } else {
        delete code2fa.recoveryKey;
      }

      try {
        this.$refs.disableAuthModal.credentialsError = false;
        await LockerService.put2faTurnOffLocker({ ...code2fa });

        this.showDisableAuthModal = false;

        this.authentication2Fa = false;
        this.showQrcode = false;
        this.timeLeftSms = 0;

        this.$store.dispatch("setUser", {
          two_factor_auth_login: false,
        });

        Swal.fire({
          icon: "success",
          title: `Two-factor authentication ${this.$ml.get("removed")}!`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        this.code2fa = "";
        this.$refs.disableAuthModal.codeEmail = "";
        this.$refs.disableAuthModal.codeInput = "";
        this.getAccount();
      } catch (error) {
        this.loading2fa = false;
        this.showDisableAuthModal = true;
        this.$refs.disableAuthModal.credentialsError = true;
        Swal.fire({
            icon: "warning",
            title: this.$ml.get("invalidCodeOrToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
      }
    },

    disableAuth(type) {
      const typesList = {
        phone: this.disablePhoneValidation,
        "2fa_locker": this.disable2faAuth,
      };

      return typesList[type]();
    },

    active2fa(tokenRecaptcha) {
      var self = this;
      if (this.$v.codeTwoFactor.$invalid) {
        this.validError = true;
        return;
      }
      this.validError = false;
      this.loadingBtn = true;

      LockerService.putTurnOnLocker({
        code: this.codeTwoFactor,
        tokenRecaptcha: tokenRecaptcha,
        lockerSmsToken: Number(this.codeSms),
      }).then(
        (response) => {
          this.codeTwoFactor = "";
          this.timeLeftSms = 0;
          this.loadingBtn = false;
          this.authentication2Fa = true;
          this.codesRecovery = response.data;
          this.$store.dispatch("setUser", {
            two_factor_auth_login: true,
          });
          Swal.fire({
            icon: "success",
            title: `Two-factor authentication ${self.$ml.get("activated")}`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          self.codeTwoFactor = "";
          this.getAccount();
        },
        (error) => {
          this.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          if (error.response.data.message === "Operação não permitida") {
            Swal.fire({
              icon: "warning",
              title: this.$ml.get("tokenORSmsInvalid"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            return;
          }
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("tryAgain"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.loadingBtn = false;
        },
      );
    },

    generateKeys() {
      var self = this;

      this.loadingBtn = true;

      LockerService.postKeysGenerate().then(
        (response) => {
          this.loadingBtn = false;
          this.codesRecovery = response.data;

          Swal.fire({
            icon: "success",
            title: self.$ml.get("successfullyGeneratedKeys"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        },
        () => {
          this.loadingBtn = false;
        },
      );
    },

    downloadCSVData() {
      let csv = "Tokens - backup\n";
      this.codesRecovery.forEach((row) => {
        csv += row + "\n";
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "ReportVault-token2fa.csv";
      anchor.click();
    },

    setRecaptchaToken(token) {
      this.tokenRecaptcha = token;
    },
  },
};
</script>

<style>
.lbl-info-methods {
  font-size: 12px;
}
.classTooltip{
  background: red !important;
}
</style>
